/* istanbul ignore file */

export { MapBox as default } from "./MapBox";
